export const ObserverTypeOptions = {
  threshold: 0.5,
}
export default function observeDomIfVisible(
  selector,
  callback,
  options = ObserverTypeOptions
) {
  const target = document.querySelector(selector)
  if (!target) { 
    return () => null
  }

  const onIntersection = (entries, opts) => {
    entries.forEach(entry => {
      callback(entry.target, entry.isIntersecting)
    })
  }
  var observer = new IntersectionObserver(onIntersection, {
    root: null, // default is the viewport
    ...options,
  })
  observer.observe(target)

  return () => {
    observer.unobserve(target)
  }
}
